import React from 'react';
import Routemap from 'routes';

const App = () => {
  return <Routemap />;
};

export default App;
